import dayjs from "dayjs"
import { Account } from "next-auth"
import { JWT } from "next-auth/jwt"
import GoogleProvider from "next-auth/providers/google"

import { Option } from "@/components/SearchModal/TSearchModal"
import {
  HomeFillIcon,
  HomeOutlineIcon,
  MailIcon,
  MailOutlineIcon,
  NewspaperIcon,
  NewspaperOutlineIcon,
  SearchFillIcon,
  SearchIcon,
  SearchOutlineIcon,
} from "@/components/icons"

interface SiteConfig {
  title: {
    default: string
    template: string
  }
  url: string
  domain?: string
  description: string
  socialLinks: {
    name: string
    slug: string
    url: string
    svg_icon: string
  }[]
  verification: {
    google?: string
  }
  yearsDesign: number
  yearsDevelopment: number
}

const todayDate = dayjs()

const startDateDesign = "2013-07-01"
const startDesign = dayjs(startDateDesign)
const yearsDesign = todayDate.diff(startDesign, "year")

// const startDateDevelopment = '2018-01-01';
// const startDevelopment = moment(startDateDevelopment);
// const durationDevelopment = moment.duration(todayDate.diff(startDevelopment));
// const yearsDevelopment = durationDevelopment.years();
const yearsDevelopment = 4

const Page_URL = process.env.URL
const DOMAIN = process.env.DOMAIN

const recommended_searches: Option[] = [
  {
    icon: SearchOutlineIcon,
    name: "Case Studies",
    type: "recommended_searches",
    uri: "/work?categories=case-study",
  },
  {
    icon: SearchOutlineIcon,
    name: "Side Projects",
    type: "recommended_searches",
    uri: "/writing?categories=side-projects",
  },
  {
    icon: SearchOutlineIcon,
    name: "Writing",
    type: "recommended_searches",
    uri: "/writing",
  },
]

const quickActions: Option[] = [
  // {
  //   type: 'quick-action',
  //   name: 'Search categories',
  //   icon: BiCategoryAlt,
  //   uri: '/work',
  // },
  // {
  //   type: 'quick-action',
  //   name: 'Search tags',
  //   icon: LuTag,
  //   uri: '/work',
  // },
]

const socialLinks = {
  behance: {
    name: "Behance",
    slug: "behance",
    svg_icon:
      '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" height="24px" width="24px" xmlns="http://www.w3.org/2000/svg"><path d="M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"></path></svg>',
    url: "https://behance.net/gil00pita",
    username: "gil00pita",
  },
  dribbble: {
    name: "Dribbble",
    slug: "dribbble",
    svg_icon:
      '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="24px" width="24px" xmlns="http://www.w3.org/2000/svg"><path d="M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8zm163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62zM44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323zm81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978z"></path></svg>',
    url: "https://dribbble.com/gil00pita",
    username: "gil00pita",
  },
  github: {
    name: "Github",
    slug: "github",
    svg_icon:
      '<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="24px" width="24px" xmlns="http://www.w3.org/2000/svg"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path></svg>',
    url: "https://github.com/gil00pita",
    username: "gil00pita",
  },
  linkedin: {
    name: "Linkedin",
    slug: "linked-in",
    svg_icon:
      '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="24px" width="24px" xmlns="http://www.w3.org/2000/svg"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path></svg>',
    url: "https://linkedin.com/in/gil-alvaro",
    username: "gil-alvaro",
  },
  twitter: {
    name: "Twitter",
    slug: "twitter",
    svg_icon:
      '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="24px" width="24px" xmlns="http://www.w3.org/2000/svg"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path></svg>',
    url: "https://twitter.com/gil00pita",
    username: "gil00pita",
  },
}

const siteMetadata: SiteConfig = {
  description: `${yearsDesign}+ years of experience - working for both the public and private sectors. Well versed in problem solving, crafting elaborate Design-Systems.`,
  domain: DOMAIN,
  socialLinks: Object.values(socialLinks).map(
    ({ name, slug, svg_icon, url }) => ({ name, slug, svg_icon, url })
  ),
  title: {
    default: "Gil Alvaro | UI Designer & UI Developer",
    template: `%s`,
  },
  url: Page_URL ?? "",
  verification: {
    google: "",
  },
  yearsDesign: yearsDesign,
  yearsDevelopment: yearsDevelopment,
}

const siteConfig = {
  inMaintenance: false,
  ...siteMetadata,
  authOptions: {
    callbacks: {
      async jwt({ account, token }: { token: JWT; account: Account | null }) {
        if (account) {
          token.accessToken = account.access_token
        }
        return token
      },
      async session({ session, token: _token }: { session: any; token: JWT }) {
        return session
      },
    },
    pages: {
      signIn: "/auth/signin",
    },
    providers: [
      GoogleProvider({
        clientId: process.env.AUTH_GOOGLE_CID!,
        clientSecret: process.env.AUTH_GOOGLE_CSEC!,
      }),
    ],
  },
  keywords:
    "UI, Design, System, Product, Developer, React, Javascript, Typescript",
  menuItems: [
    {
      active: true,
      id: "1",
      name: "Home",
      react_icon_name: HomeOutlineIcon,
      react_icon_name_filled: HomeFillIcon,
      slug: "/",
      svg_icon:
        '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="24px" width="24px" xmlns="http://www.w3.org/2000/svg"><path d="M21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V9.48907C3 9.18048 3.14247 8.88917 3.38606 8.69972L11.3861 2.47749C11.7472 2.19663 12.2528 2.19663 12.6139 2.47749L20.6139 8.69972C20.8575 8.88917 21 9.18048 21 9.48907V20ZM19 19V9.97815L12 4.53371L5 9.97815V19H19ZM7 15H17V17H7V15Z"></path></svg>',
      visibleInNavbar: false,
    },
    {
      active: true,
      id: "2",
      name: "Work",
      react_icon_name: NewspaperOutlineIcon,
      react_icon_name_filled: NewspaperIcon,
      slug: "/work",
      svg_icon:
        '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="24px" width="24px" xmlns="http://www.w3.org/2000/svg"><path d="M426.2 80.4l-170.2 32-170.2-32C64 77 48 97.3 48 118v244.5c0 20.7 16 32.6 37.8 37.6L256 432l170.2-32c21.8-5 37.8-16.9 37.8-37.6V118c0-20.7-16-41-37.8-37.6zm0 282l-151.2 32V149.9l151.2-32v244.5zm-189.2 32l-151.2-32V118L237 150v244.4z"></path></svg>',
      visibleInNavbar: true,
    },
    {
      active: true,
      id: "3",
      name: "Contact",
      react_icon_name: MailOutlineIcon,
      react_icon_name_filled: MailIcon,
      slug: "/contact",
      svg_icon:
        '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 256 256" height="200px" width="200px" xmlns="http://www.w3.org/2000/svg"><path d="M172,112a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h68A8,8,0,0,1,172,112Zm-8,24H96a8,8,0,0,0,0,16h68a8,8,0,0,0,0-16Zm68-12A100.11,100.11,0,0,1,132,224H48a16,16,0,0,1-16-16V124a100,100,0,0,1,200,0Zm-16,0a84,84,0,0,0-168,0v84h84A84.09,84.09,0,0,0,216,124Z"></path></svg>',
      visibleInNavbar: false,
    },
  ],
  ogImage: `${(process.env.DIRECTUS_ASSETS_URL ?? "").replace(/\/$/, "")}/d121f00c-d965-409f-bc68-ecf898ad13f5?width=1200&height=630&fit=cover&format=jpg&quality=85`,
  quick_actions: quickActions,
  recommended_searches: recommended_searches,
  searchIcon: SearchIcon,
  searchIconFilled: SearchFillIcon,
  showSearch: true,
  showTestimonials: true,
  socialLinks,
}

export const logMessage = String.raw`                                                                               
       ::::::             __        __   _                              _                                  
     ::::::::             \ \      / /__| | ___ ___  _ __ ___   ___    | |_ ___                             
    :::::::::              \ \ /\ / / _ \ |/ __/ _ \| |_   _ \ / _ \   | __/ _ \                            
   ::::::                   \ V  V /  __/ | (_| (_) | | | | | |  __/   | || (_) |                           
   :::::     ++++++++++      \_/\_/ \___|_|\___\___/|_| |_| |_|\___|   \__ \___/                            
   :::::     ++++++++++                                                                                     
             ++++++++++      __________       _    ____      __    ____   ___   _____ __ ___  ____          
                 ++++++    / ___|_ _| |      / \  | |\ \   / / \  |  _ \ / _ \ / ___/ _ \|  \/  | |         
             +++++++++    | |  _ | || |     / _ \ | | \ \ / / _ \ | |_) | | | | |  | | | | |\/| | |         
             ++++++++     | |_| || || |___ / ___ \| |__\ V / ___ \|  _ <| |_| | |__| |_| | |  | |_|         
             +++++         \____|___|_____/_/   \_\_____\_/_/   \_\_| \_\\___(_)____\___/|_|  |_(_)         
                                                                                                            
                                                                                       |E]                  
   Hi there, fellow developer or curious mind!                                        .-|=====-.            
   Thank you for visiting my personal portfolio.                                      | | mail |            
   If you like what you see, feel free to contact me.                              ___|________|            
   I'm always looking for new opportunities and collaborations.                           ||                
   http://gilalvaro.com/contact                                                       ||                
                                                                                          ||   www          
   I'd love to hear what you think!                                                ,;,    ||   )_(,;;;,)    
                                                                                   <_>  \ ||   \|/ \_/      
    — Gil Alvaro                                                                   <_>  \ ||   \|/ \_/      
                                                                              _jgs_\|//_\\|///_\V/_\|//__   `

export default siteConfig
